export function parseClipboardData(clipboardText: string): string[] {
    // split by newline, and trim the newline characters
    const lines = clipboardText.split("\n").map((line) => line.trim());
    // For excel, split every line into cells delimited by tab, and reduce to we have one flat list
    const cells = lines.flatMap((line) => line.split("\t")).filter((cell) => cell.trim() !== "");

    return cells;
}
